import React from "react";
import { Alert, Form, Icon, Button, Row, Col, Upload, message } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

import {
  uploadSpecimenSampleRequest,
  specimenSchemaDownload,
} from "../../../api/requests";
import {
  getSpecimenSampleCreatePermission,
  getSpecimenSampleUpdatePermission,
  getUserTimezone,
  getUserShortTimezone,
} from "../../../reducers/user/selectors";

import classes from "./SpecimenSampleUploadForm.css";
import { logout } from "../../../reducers/user/actions";

class SpecimenSampleUploadForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      loadingSchema: false,
      requestResult: {},
    };
  }

  downloadSchema = async () => {
    try {
      this.setState(() => ({
        loadingSchema: true,
      }));

      let data = null;

      const response = await specimenSchemaDownload();
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `specimen-sample-example.csv`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      loadingSchema: false,
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const formData = new FormData();
          if (values.document_file && values.document_file.file) {
            formData.append("document_file", values.document_file.file);
          }
          // formData.append('location_id', values.location_id);
          await uploadSpecimenSampleRequest(formData);

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: this.props.i18n.t("Success") },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">{this.props.i18n.t("NamespaceSpecimenSample:Upload Specimen Samples")}</h4>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("Select .csv")}</b>
                <Form.Item>
                  {getFieldDecorator("document_file", {
                    initialValue: get(this.props, "document_file", ""),
                  })(
                    <Upload
                      accept=".csv"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("document_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue("document_file") &&
                        this.props.url
                          ? this.props.i18n.t("Change file")
                          : this.props.i18n.t("NamespaceSpecimenSample:Upload Specimen Samples")}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </label>

              {!this.props.form.getFieldValue("document_file") &&
                this.props.url && (
                  <div>
                    <a href={this.props.url} target="_blank">
                      {this.props.url}
                    </a>
                    <br />
                    <br />
                  </div>
                )}
            </Col>

            <Col md={24}>
              {this.props.i18n.t(".CSV example")}:{" "}
              <Button
                onClick={() => this.downloadSchema()}
                disabled={this.state.loadingSchema}
                loading={this.state.loadingSchema}
                type="primary"
                size="small"
              >
                {this.props.i18n.t("Download")}
              </Button>
              <br />
              <br />
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
              >
                {this.props.i18n.t("Save")}
                {isLoading && <Icon type="loading" />}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  specimenSampleCreatePermission: getSpecimenSampleCreatePermission(state),
  specimenSampleUpdatePermission: getSpecimenSampleUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "SpecimenSampleUploadForm" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SpecimenSampleUploadForm))
);



// WEBPACK FOOTER //
// ./src/containers/SpecimenSampleEditor/SpecimenSampleUploadForm/SpecimenSampleUploadForm.js